// Верхняя строка: кнопка меню, в чате — «Назад / Вперёд» и название открытого сценария, справа — инструменты.
import { routeStore } from "../router";
import { Store, useStore } from "../store";
import { Icon } from "./Icon";
import { expandViewer, viewerStore, ViewerTabs } from "./Viewer";

export type WorkspaceView = {
  barHidden: boolean; title: string; kind: string; backDisabled: boolean; forwardDisabled: boolean;
  onBack: () => void; onForward: () => void;
};
export const workspaceStore = new Store<WorkspaceView | null>(null);

function ReviewSymbol() {
  return (
    <svg viewBox="0 0 40 40" fill="none" aria-hidden="true">
      <path d="M11 5h13l6 6v22H11z" fill="#A8CEBD" /><path d="M8 4h14l6 6v21H8z" fill="#F5FAF5" /><path d="M22 4v6h6" fill="#C4DDCE" />
      <path d="M12 15h11M12 19h11M12 23h7" stroke="#9FBAAC" strokeWidth="1.5" strokeLinecap="round" /><path d="M26 19h6v9h5l-8 9-8-9h5z" fill="#DFC07D" />
    </svg>
  );
}

export function Topbar({ openRef, expanded, onOpen, onHelp }: {
  openRef: React.Ref<HTMLButtonElement>; expanded: boolean; onOpen: () => void; onHelp: () => void;
}) {
  const workspace = useStore(workspaceStore);
  const { page } = useStore(routeStore);
  const viewer = useStore(viewerStore);
  const wide = Boolean(viewer.target && viewer.expanded);   // развёрнутый просмотр документа: вместо меню — вкладки
  const showBar = page === "chat" && workspace !== null && !workspace.barHidden;
  return (
    <header className={`topbar${showBar ? " has-workspace" : ""}${wide ? " has-tabs" : ""}`}>
      {wide && <ViewerTabs />}
      <button ref={openRef} className="icon-button" type="button" aria-label="Открыть меню" aria-controls="sidebar" aria-expanded={expanded} onClick={onOpen}>
        <Icon name="panel" />
      </button>
      {page === "chat" && workspace && (
        <div className="workspace-nav" hidden={!showBar}>
          <nav className="workspace-history" aria-label="Переходы по рабочему пространству">
            <button type="button" className="workspace-back" aria-label="Назад" title="Назад" disabled={workspace.backDisabled} onClick={workspace.onBack}>
              <Icon name="arrow" /><span>Назад</span>
            </button>
            <button type="button" aria-label="Вперёд" title="Вперёд" disabled={workspace.forwardDisabled} onClick={workspace.onForward}><Icon name="arrow" /></button>
          </nav>
          <div className="workspace-heading">
            <span className="workspace-symbol" hidden={workspace.kind !== "review"}><ReviewSymbol /></span>
            <span className="workspace-symbol" hidden={workspace.kind !== "calc"}><Icon name="calc" /></span>
            <span className="workspace-symbol" hidden={workspace.kind !== "doc"}><Icon name="doc" /></span>
            <span className="workspace-symbol" hidden={workspace.kind !== "chat"}><Icon name="chat" /></span>
            <span className="workspace-symbol is-home" hidden={workspace.kind !== "home"}><Icon name="grid" /></span>
            <span className="workspace-title" title={workspace.title} aria-live="polite">{workspace.title}</span>
          </div>
        </div>
      )}
      <div className="topbar-tools">
        {wide && (
          <button className="icon-button viewer-collapse" type="button" aria-label="Свернуть просмотр" title="Свернуть" onClick={() => expandViewer(false)}>
            <Icon name="collapse" />
          </button>
        )}
        <span className="region-label"><Icon name="globe" />Право РФ</span>
        <button className="icon-button help-button" type="button" aria-label="Как работает Правосвод" title="Как работает Правосвод" onClick={onHelp}>
          <Icon name="help" />
        </button>
      </div>
    </header>
  );
}
